var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 1.16797C6.28241 1.16797 5.31481 1.47352 4.5 2.08464L2.48333 3.59714C2.02169 3.94337 1.75 4.48675 1.75 5.0638V12.9737C1.75 14.4358 3.4191 15.2703 4.58871 14.3931C5.37724 13.8017 6.31362 13.506 7.25 13.506M7.25 1.16797C8.21759 1.16797 9.18519 1.47352 10 2.08464L10.0887 2.15117C10.8772 2.74257 11.8136 3.03826 12.75 3.03826M7.25 1.16797V1.85547V12.8555V13.506M12.75 3.03826C13.6864 3.03826 14.6228 2.74257 15.4113 2.15117C16.5809 1.27396 18.25 2.10851 18.25 3.57052V11.4805C18.25 12.0575 17.9783 12.6009 17.5167 12.9471L15.5 14.4596C14.6852 15.0707 13.7176 15.3763 12.75 15.3763M12.75 3.03826V3.6888V14.6888V15.3763M12.75 15.3763C11.7824 15.3763 10.8148 15.0707 10 14.4596L9.91129 14.3931C9.12276 13.8017 8.18638 13.506 7.25 13.506",
    opacity: 0.5,
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.db305bdf.svg";
export { ForwardRef as ReactComponent };